import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
  field: {
    marginBottom: theme.spacing(2),
  },
}));
